import _ from 'lodash'

export function filterList<T>(elements: T[], filterFields: string[], query: string): T[] {
  if (!query) {
    return elements
  }

  query = query.toLowerCase()

  return elements.filter(el =>
    filterFields.find(field => {
      const value = _.get(el, field, '')
      return String(value || '').toLowerCase().includes(query)
    })
  )
}
